import React from 'react';
import Logo from '../Logo/PDTRLOGO.png';

const BillPrint = ({ onClose, labelData }) => {
    // Function to format the date
    const formatDate = (dateString) => {
        const options = { year: 'numeric', month: 'long', day: 'numeric' };
        return new Date(dateString).toLocaleDateString('en-US', options);
    };

    // Styles for the invoice
    const containerStyle = {
        border: '1px solid #000',
        padding: '20px',
        fontFamily: 'Arial, sans-serif',
        color: '#333',
        lineHeight: '1.5',
        fontSize: '12px',
    };

    // Styles for the table cells
    const cellStyle = {
        border: '1px solid #000',
        padding: '8px',
    };

    const cellStyleN = {
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'right'
    };

    const cellStyleP = {
        border: '1px solid #000',
        padding: '8px',
        textAlign: 'left'
    };


    // Styles for the table
    const tableStyle = {
        width: '100%',
        borderCollapse: 'collapse',
        textAlign: 'center',
        marginTop: '30px'
    };

    // Styles for the footer
    const footerStyle = {
        textAlign: 'center',
        marginTop: '20px',
        borderTop: '1px solid #eee',
        paddingTop: '10px',
    };

    const NumberToWords = (num) => {
        const units = ['', 'One', 'Two', 'Three', 'Four', 'Five', 'Six', 'Seven', 'Eight', 'Nine'];
        const teens = ['Eleven', 'Twelve', 'Thirteen', 'Fourteen', 'Fifteen', 'Sixteen', 'Seventeen', 'Eighteen', 'Nineteen'];
        const tens = ['', 'Ten', 'Twenty', 'Thirty', 'Forty', 'Fifty', 'Sixty', 'Seventy', 'Eighty', 'Ninety'];

        const convert = (num) => {
            if (num < 10) return units[num];
            if (num < 20) return num === 10 ? 'Ten' : teens[num - 11];
            if (num < 100) return tens[Math.floor(num / 10)] + (num % 10 ? ' ' + units[num % 10] : '');
            if (num < 1000) return units[Math.floor(num / 100)] + ' Hundred' + (num % 100 ? ' ' + convert(num % 100) : '');
            if (num < 100000) return convert(Math.floor(num / 1000)) + ' Thousand' + (num % 1000 ? ' ' + convert(num % 1000) : '');
            if (num < 10000000) return convert(Math.floor(num / 100000)) + ' Lakh' + (num % 100000 ? ' ' + convert(num % 100000) : '');
            return 'Number is too large';
        };

        if (num === 0) return 'Zero';
        return convert(num);
    };

    const AmountInWords = ({ amount }) => {
        const formattedAmount = parseFloat(amount).toFixed(2);
        const [rupees, decimal] = formattedAmount.split('.');

        return (
            <div>
                <h5>Rs: {NumberToWords(parseInt(rupees))} Only</h5>
                {decimal !== "00" && <p>{NumberToWords(parseInt(decimal))} Paisa Only</p>}
            </div>
        );
    };

    // Render the invoice
    return (
        <div style={containerStyle}>

            {/* <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', marginBottom: '0px', position: 'relative' }}>
                <img src={logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto' }} />
            </div> */}

            <div style={{ textAlign: 'center', marginBottom: '0px' }}>
                <img src={Logo} alt="Company Logo" style={{ maxHeight: '80px', margin: '0 auto', width: '103%', height: '75%' ,marginLeft:'-10px'}} />
            </div>

            <div className="w-full sm:w-1/2" style={{ marginTop: '10px' }}>
                <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '50%', textAlign: 'right', padding: 0 }}>
                            </td>

                            <td style={{ width: '50%', textAlign: 'right', padding: 0 }}>
                                <h3 style={{ textAlign: 'right', marginTop: '20px' }}>Bill No : {labelData.ReferenceNo}</h3>
                                <h3 style={{ textAlign: 'right', padding: 0 }}>Bill Date: {formatDate(labelData.ReferenceDate)}</h3>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '100%', textAlign: 'center', padding: 0 }}>
                                <h2 style={{ textAlign: 'center', padding: '0 0 5px 0', margin: 0 }}>RECEIPT</h2>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '100%', textAlign: 'left', padding: 0 }}>
                                <h3 style={{ textAlign: 'left', padding: '0 0 5px 0', margin: 0 }}>Received with thanks from {labelData.PartyName} By {labelData.PaymentType} a sum of Rs: {labelData.Amount} only</h3>
                            </td>
                        </tr>

                    </tbody>
                </table>
            </div>

            <div className="w-full sm:w-1/2">
                <table style={{ width: '100%', marginTop: '30px', borderCollapse: 'collapse' }}>
                    <tbody>
                        <tr>
                            <td style={{ width: '40%', textAlign: 'left', padding: 0 }}>

                                <h3>Rs: {labelData.Amount}</h3>
                                <h4><AmountInWords amount={labelData.Amount} /></h4>

                            </td>
                            {/* <td style={{ width: '60%', textAlign: 'right', padding: 0 }}>
                                <img src={signseal} alt="QR Code" style={{ marginTop: '3px', position: 'relative', maxWidth: '150px', maxHeight: '150px', transform: 'translateX(-50%)' }} />
                            </td> */}
                        </tr>
                    </tbody>
                </table>
            </div>

            {/* Print-specific styles */}
            <style>
                {`
                    @media print {
                        body {
                            margin: 10;
                            padding: 0;
                        }
                        @page {
                            size: A4;
                            margin: 0;
                        }
                        .no-print {
                            display: none;
                        }
                    }
                `}
            </style>
        </div>
    );
};

export default BillPrint;
